import React, {useEffect} from "react";
import './App.css';
import Navbar from "./components/Navbar";
import Hero from "./components/sections/Hero";
import Director from "./components/sections/Director";
import About from "./components/sections/About";
import Volunteers from "./components/sections/Volunteers";
import Projects from "./components/sections/Projects";
import Footer from "./components/Footer";

function App() {

    useEffect(() => {
        const els = document.querySelectorAll('.reveal');
        const reveal = (el) => el.classList.add('is-visible');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Без поддержки IntersectionObserver или при reduce-motion ничего не прячем —
        // контент остаётся видимым по умолчанию (см. .reveal в App.css).
        if (reduceMotion || !('IntersectionObserver' in window)) {
            return;
        }

        // Включаем режим анимации только сейчас, когда JS точно работает.
        document.documentElement.classList.add('anim-ready');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    reveal(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, {threshold: 0.12, rootMargin: '0px 0px -8% 0px'});

        els.forEach((el) => observer.observe(el));

        // Страховка: если наблюдатель/таймеры задушены (эконом-режим, фоновая вкладка) —
        // через 3 секунды принудительно показываем всё, чтобы блоки не пропали.
        const fallback = setTimeout(() => els.forEach(reveal), 3000);

        return () => {
            observer.disconnect();
            clearTimeout(fallback);
        };
    }, []);

    return (
        <div className="site">
            <Navbar/>
            <main>
                <Hero/>
                <Director/>
                <About/>
                <Volunteers/>
                <Projects/>
            </main>
            <Footer/>
        </div>
    );
}

export default App;
